import { Http } from 'services/http';
import { API_CHAT_URL } from 'consts/common.const';

export const getUserObject = (userId: string | number) => {
  return Http.request({
    method: 'GET',
    url: `${API_CHAT_URL}/user/get-user-object/${userId}`,
  });
};
